import { useTranslation } from 'react-i18next';
import { Button, ErrorSummary } from '../idsk';

/** Shown when the server answers 409 VERSION_CONFLICT: explains and offers to load the current version. */
export function VersionConflictSummary({ onReload, focusKey }: { onReload: () => void; focusKey?: unknown }) {
  const { t } = useTranslation();
  return (
    <ErrorSummary errors={[]} focusKey={focusKey} title={t('errorSummary.title')}>
      <p className="govuk-body">{t('errors.versionConflict')}</p>
      <Button variant="secondary" onClick={onReload}>
        {t('common.reloadCurrent')}
      </Button>
    </ErrorSummary>
  );
}
